import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

interface WolfHelperNavigationProps {
  type: 'title' | 'section';
  label: string;
  selected: boolean;
  onSelect: () => void;
}

interface NavigationItemProps {
  selected: boolean;
}

const NavigationItem = styled(Box, { shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'type' })<
  NavigationItemProps & { type: 'title' | 'section' }
>(({ theme, selected, type }) => ({
  height: type === 'title' ? 40 : 32,
  width: 'fit-content',
  backgroundColor: selected ? theme.palette.frozenGrayShades2.main : theme.palette.backgroundUI.main,
  borderRadius: '4px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: selected ? theme.palette.frozenGrayShades3.main : theme.palette.frozenGrayShades3.main,
  },
  display: 'flex',
  alignItems: 'center',
}));

const WolfHelperNavigation: React.FC<WolfHelperNavigationProps> = ({ type = 'title', label, selected, onSelect }) => {
  return (
    <Box className="flex flex-wrap m-1">
      {type === 'section' && <Box className="w-1 xl:w-4"></Box>}
      <NavigationItem selected={selected} type={type} onClick={onSelect} className="p-1 xl:p-4">
        <Typography
          className="text-ellipsis max-w-[120px] lg:max-w-[160px] xl:max-w-full overflow-hidden xs:overflow-hidden xl:overflow-visible xs:text-ellipsis xl:text-clip whitespace-nowrap xs:whitespace-nowrap xl:whitespace-normal block"
          color="primary"
          title={label}
          variant={
            selected ? (type === 'title' ? 'body14semibold' : 'body12semibold') : type === 'title' ? 'body14' : 'body12'
          }>
          {label.slice(0, 45)}
        </Typography>
      </NavigationItem>
    </Box>
  );
};

export default WolfHelperNavigation;
